'use strict';
import {reduxList as assetsProjectsList} from '../redux/assetsProjectsList';
import {createAssetRequestModal} from '../redux/createAsset';
import {deleteAssetRequest} from '../redux/deleteAsset';
import {updateAssetRequestModal} from '../redux/updateAsset';


export const epics = [
  ...assetsProjectsList.epics.epics,
  ...createAssetRequestModal.epics.epics,
  ...deleteAssetRequest.epics.epics,
  ...updateAssetRequestModal.epics.epics,
];



// WEBPACK FOOTER //
// ./src/js/assets/epics/index.js